import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyConnectProjectRoute: InvariantJiraRoute = {
	name: 'legacy-connect-project',
	path: '/projects/:projectKey',
	query: ['selectedItem'],
};
